import { render, staticRenderFns } from "./receive_money_qr.vue?vue&type=template&id=c5321c58&"
import script from "./receive_money_qr.vue?vue&type=script&lang=js&"
export * from "./receive_money_qr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports